// import React, { useState, useEffect } from 'react';
// import { IconButton, InputAdornment, TextField, Button, InputLabel } from '@mui/material';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import LocalIP from '../../api/LocalIP';
// import Cookies from 'js-cookie';
// import Icon from 'react-icons-kit';
// import { arrows_exclamation } from 'react-icons-kit/linea/arrows_exclamation';
// import { arrows_circle_check } from 'react-icons-kit/linea/arrows_circle_check';
// import UserSettingsAPISvc from '../../api-layer/user-settings-svc';

// const UserSettings = () => {
//   const location = useLocation();
//   const tokenFromUrl = new URLSearchParams(location.search).get('token');
//   const navigate = useNavigate();

//   const [values, setValues] = useState({
//     pwResetToken: tokenFromUrl || '',
//     newPassword: '',
//     confirmPassword: '',
//     showPassword: false,
//     showConfirmPassword: false
//   });

//   const [formErrors, setFormErrors] = useState({
//     passwordError: false,
//     confirmPasswordError: false
//   });

//   const [isPasswordActive, setIsPasswordActive] = useState(false);
//   const [isFormValid, setIsFormValid] = useState(false);

//   const [validationResults, setValidationResults] = useState({
//     lowerValidated: false,
//     upperValidated: false,
//     numberValidated: false,
//     specialValidated: false,
//     lengthValidated: false
//   });

//   useEffect(() => {
//     setIsFormValid(values.newPassword && values.confirmPassword && !Object.values(formErrors).some((error) => error));

//     if (isPasswordActive) {
//       const lower = new RegExp('(?=.*[a-z])');
//       const upper = new RegExp('(?=.*[A-Z])');
//       const number = new RegExp('(?=.*[0-9])');
//       const special = new RegExp('(?=.*[!@#$%^&*])');
//       const length = new RegExp('(?=.{8,})');

//       setValidationResults({
//         lowerValidated: lower.test(values.newPassword),
//         upperValidated: upper.test(values.newPassword),
//         numberValidated: number.test(values.newPassword),
//         specialValidated: special.test(values.newPassword),
//         lengthValidated: length.test(values.newPassword)
//       });
//     }
//   }, [values, formErrors, isPasswordActive]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setIsPasswordActive(true);
//     setValues((prevValues) => ({
//       ...prevValues,
//       [name]: value
//     }));

//     if (name === 'confirmPassword') {
//       setFormErrors((prevErrors) => ({
//         ...prevErrors,
//         [`${name}Error`]: value.trim() === '' || value !== values.newPassword
//       }));
//     } else {
//       setFormErrors((prevErrors) => ({
//         ...prevErrors,
//         [`${name}Error`]: value.trim() === ''
//       }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (values.newPassword !== values.confirmPassword) {
//       toast.error('The passwords do not match. Please try again.');
//       return;
//     }

//     try {
//       const response = await UserSettingsAPISvc.handlePasswordReset({
//         newPassword: values.newPassword,
//         pwResetToken: values.pwResetToken
//       });

//       if (response.statusCode === 200) {
//         setValues((prevValues) => ({
//           ...prevValues,
//           newPassword: ''
//         }));
//         toast.success('Password changed successfully.');
//         navigate('/passwordsuccess');
//       }
//     } catch (err) {
//       const errorMessage = err.response?.data?.message || 'An unexpected error occurred during password change.';
//       console.error(err);
//       toast.error(errorMessage);
//     }
//   };

//   return (
//     <div
//       className='grid grid-flow-row sm:grid-flow-col gap-0.5 font-inter min-h-screen relative'
//       style={{
//         background: 'linear-gradient(146deg, rgba(23,39,92,1) 9%, rgba(26,45,97,1) 24%, rgba(27,49,100,1) 33%, rgba(58,138,165,1) 100%)',
//         backgroundColor: 'rgb(23,39,92)'
//       }}>
//       <div className='sm:col-span-12 md:col-span-6 flex justify-center items-center text-3xl rounded-xl p-2'></div>
//       <div className='sm:col-span-6 flex justify-center items-center text-3xl p-2 border-l-2 relative' style={{ borderColor: '#214471' }}>
//         <div className='w-full flex justify-center items-center ml-4'>
//           <div className='absolute inset-y-1/2 ml-4 pl-14 transform -translate-y-1/2 sm:right-25 w-2/3 bg-white rounded-lg h-2/3 '>
//             <div className='flex flex-col items-start mt-16'>
//               <h1 className='text-black font-bold text-xl mb-1 ml-10'>Create New Password</h1>
//               <p className='text-base px-6 sm:px-10 mt-6 mb-6 mr-20'>Your new password must be different from the previous password.</p>
//             </div>
//             <form className='flex flex-col w-full items-left ml-10 mb-20'>
//               {/* New Password Input */}
//               <div className='flex flex-col mb-4 w-96'>
//                 <InputLabel htmlFor='new-password' className='mr-8 mt-5 mb-2 text-base'>
//                   New Password
//                 </InputLabel>
//                 <TextField
//                   type={values.showPassword ? 'text' : 'password'}
//                   variant='outlined'
//                   size='small'
//                   className={`mt-2`}
//                   InputProps={{
//                     style: {
//                       background: 'white',
//                       borderColor: formErrors.passwordError ? 'red' : 'initial',
//                       boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)'
//                     },
//                     endAdornment: (
//                       <InputAdornment position='end'>
//                         <IconButton
//                           edge='end'
//                           aria-label='toggle password visibility'
//                           onClick={() =>
//                             setValues((prevValues) => ({
//                               ...prevValues,
//                               showPassword: !prevValues.showPassword
//                             }))
//                           }>
//                           {values.showPassword ? <VisibilityOff /> : <Visibility />}
//                         </IconButton>
//                       </InputAdornment>
//                     )
//                   }}
//                   placeholder='New Password'
//                   value={values.newPassword}
//                   onChange={handleInputChange}
//                   name='newPassword'
//                   required
//                   error={formErrors.passwordError}
//                 />
//                 {formErrors.passwordError && <p className='text-red-500 text-sm'>Please enter at least 8 characters with numbers, letters, symbols, and both capital and small letters.</p>}
//               </div>

//               {/* Confirm Password Input */}
//               <div className='flex flex-col mb-4 w-96'>
//                 <InputLabel htmlFor='confirm-password' className='mr-8 mt-5 mb-2'>
//                   Confirm Password
//                 </InputLabel>
//                 <TextField
//                   type={values.showConfirmPassword ? 'text' : 'password'}
//                   variant='outlined'
//                   size='small'
//                   className={`mt-2`}
//                   InputProps={{
//                     style: {
//                       background: 'white',
//                       borderColor: formErrors.confirmPasswordError ? 'red' : 'initial',
//                       boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)'
//                     },
//                     endAdornment: (
//                       <InputAdornment position='end'>
//                         <IconButton
//                           edge='end'
//                           aria-label='toggle password visibility'
//                           onClick={() =>
//                             setValues((prevValues) => ({
//                               ...prevValues,
//                               showConfirmPassword: !prevValues.showConfirmPassword
//                             }))
//                           }>
//                           {values.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
//                         </IconButton>
//                       </InputAdornment>
//                     )
//                   }}
//                   placeholder='Confirm Password'
//                   value={values.confirmPassword}
//                   onChange={handleInputChange}
//                   name='confirmPassword'
//                   required
//                   error={formErrors.confirmPasswordError}
//                 />
//                 {formErrors.confirmPasswordError && <p className='text-red-500 text-sm'>The passwords do not match. Please try again.</p>}
//               </div>
//               {/* Save and Cancel Buttons */}
//               <div className='flex items-center justify-center mt-10 gap-3'>
//                 <div className='flex justify-end'>
//                   <Button
//                     type='submit'
//                     variant='contained'
//                     color='primary'
//                     onClick={handleSubmit}
//                     sx={{ textTransform: 'none' }}
//                     className='w-30 h-8 rounded-md mb-4 font-bold text-lg text-sm '
//                     disabled={!isFormValid}
//                     style={{
//                       boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
//                       color: !isFormValid ? '' : 'white',
//                       backgroundColor: !isFormValid ? '' : '#081A51',
//                       fontWeight: !isFormValid ? '' : 'bold',
//                       opacity: 1,
//                       pointerEvents: 'auto',
//                       cursor: !isFormValid ? '' : 'pointer'
//                     }}>
//                     Reset Password
//                   </Button>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UserSettings;

import React, { useState, useEffect } from 'react';
import { IconButton, InputAdornment, TextField, Button, InputLabel } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Checkbox, FormControlLabel } from '@mui/material';
import UserSettingsAPISvc from '../../api-layer/user-settings-svc';

const UserSettings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const tokenFromUrl = new URLSearchParams(location.search).get('token');

  const [values, setValues] = useState({
    pwResetToken: tokenFromUrl || '',
    newPassword: '',
    confirmPassword: '',
    showPassword: false,
    showConfirmPassword: false
  });

  const [validationResults, setValidationResults] = useState({
    lowerValidated: false,
    upperValidated: false,
    numberValidated: false,
    specialValidated: false,
    lengthValidated: false
  });

  const [formErrors, setFormErrors] = useState({
    confirmPasswordError: false
  });

  useEffect(() => {
    const lower = new RegExp('(?=.*[a-z])');
    const upper = new RegExp('(?=.*[A-Z])');
    const number = new RegExp('(?=.*[0-9])');
    const special = new RegExp('(?=.*[!@#$%^&*])');
    const length = new RegExp('(?=.{8,})');

    setValidationResults({
      lowerValidated: lower.test(values.newPassword),
      upperValidated: upper.test(values.newPassword),
      numberValidated: number.test(values.newPassword),
      specialValidated: special.test(values.newPassword),
      lengthValidated: length.test(values.newPassword)
    });

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      confirmPasswordError: values.confirmPassword && values.newPassword !== values.confirmPassword
    }));
  }, [values]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value
    }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (values.newPassword !== values.confirmPassword) {
  //     toast.error('Passwords do not match.');
  //     return;
  //   }

  //   try {
  //     console.log('Making API call...'); // Debug log
  //     const response = await UserSettingsAPISvc.handlePasswordReset({
  //       newPassword: values.newPassword,
  //       pwResetToken: values.pwResetToken
  //     });
  //     console.log("After API call:", response);
  //     if (response.statusCode === 200) {
  //       toast.success('Password changed successfully.');
  //       navigate('/passwordsuccess');
  //     }
  //   } catch (err) {
  //     toast.error('An error occurred. Please try again.');
  //   }
  // };

    const handleSubmit = async (e) => {
    e.preventDefault();

    if (values.newPassword !== values.confirmPassword) {
      toast.error('The passwords do not match. Please try again.');
      return;
    }

    try {
      const response = await UserSettingsAPISvc.handlePasswordReset({
        newPassword: values.newPassword,
        pwResetToken: values.pwResetToken
      });

      if (response.statusCode === 200) {
        setValues((prevValues) => ({
          ...prevValues,
          newPassword: ''
        }));
        toast.success('Password changed successfully.');
        navigate('/passwordsuccess');
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'An unexpected error occurred during password change.';
      console.error(err);
      toast.error(errorMessage);
    }
  };
  return (
    <div
      className='grid grid-cols-1 lg:grid-cols-2 min-h-screen font-inter'
      style={{
        background: 'linear-gradient(146deg, rgba(23,39,92,1) 9%, rgba(26,45,97,1) 24%, rgba(27,49,100,1) 33%, rgba(58,138,165,1) 100%)',
        backgroundColor: 'rgb(23,39,92)'
      }}>
      <div className='hidden lg:flex items-center justify-center text-3xl text-white p-4'>{/* Left content for larger screens */}</div>

      <div className='flex items-center justify-center px-6 py-8 lg:py-0 bg-red lg:border-l-2' style={{ borderColor: '#214471' }}>
        <div className='w-full max-w-md bg-white p-6 rounded-lg shadow-md'>
          <h1 className='text-xl font-bold text-center text-black mb-4'>Create New Password</h1>
          <p className='text-gray-600 text-center mb-8'>Your new password must be different from the previous password.</p>

          <form onSubmit={handleSubmit} className='space-y-4'>
            <div>
              <InputLabel>New Password</InputLabel>
              <TextField
                fullWidth
                type={values.showPassword ? 'text' : 'password'}
                value={values.newPassword}
                name='newPassword'
                onChange={handleInputChange}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        onClick={() =>
                          setValues((prev) => ({
                            ...prev,
                            showPassword: !prev.showPassword
                          }))
                        }>
                        {values.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </div>
            <div>
              <InputLabel>Confirm Password</InputLabel>
              <TextField
                fullWidth
                type={values.showConfirmPassword ? 'text' : 'password'}
                value={values.confirmPassword}
                name='confirmPassword'
                onChange={handleInputChange}
                error={formErrors.confirmPasswordError}
                helperText={formErrors.confirmPasswordError && 'Passwords do not match.'}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        onClick={() =>
                          setValues((prev) => ({
                            ...prev,
                            showConfirmPassword: !prev.showConfirmPassword
                          }))
                        }>
                        {values.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </div>
            <div className='space-y-0.5'>
              <FormControlLabel control={<Checkbox checked={validationResults.lowerValidated} />} label='At least one lowercase letter' />
              <FormControlLabel control={<Checkbox checked={validationResults.upperValidated} />} label='At least one uppercase letter' />
              <FormControlLabel control={<Checkbox checked={validationResults.numberValidated} />} label='At least one number' />
              <FormControlLabel control={<Checkbox checked={validationResults.specialValidated} />} label='At least one special character (!@#$%^&*)' />
              <FormControlLabel control={<Checkbox checked={validationResults.lengthValidated} />} label='At least 8 characters long' />
            </div>
            <Button
  type="submit"
  fullWidth
  variant="contained"
  color="primary"
  disabled={!Object.values(validationResults).every(Boolean) || values.newPassword !== values.confirmPassword}
  style={{
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
    color: !Object.values(validationResults).every(Boolean) || values.newPassword !== values.confirmPassword ? '' : 'white',
    backgroundColor: !Object.values(validationResults).every(Boolean) || values.newPassword !== values.confirmPassword ? '' : '#081A51',
    fontWeight: !Object.values(validationResults).every(Boolean) || values.newPassword !== values.confirmPassword ? '' : 'bold',
    opacity: 1,
    pointerEvents: 'auto',
    cursor: !Object.values(validationResults).every(Boolean) || values.newPassword !== values.confirmPassword ? '' : 'pointer'
  }}>
  Reset Password
</Button>

          </form>
        </div>
      </div>
    </div>
  );
};

export default UserSettings;
